import React from "react";
import {
  Alert,
  Form,
  Input,
  Select,
  Checkbox,
  Button,
  Row,
  Col,
  Icon,
  Badge,
  InputNumber,
  DatePicker,
  Radio,
  Slider,
  Tooltip,
  notification,
  TimePicker,
  Upload,
} from "antd";
import map from "lodash/map";
import get from "lodash/get";
import flatten from "lodash/flatten";
import forEach from "lodash/forEach";
import classNames from "classnames";
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from "react-sortable-hoc";
import { v4 as uuidv4 } from "uuid";

import arrayMove from "../../utils/arrayMove";

import classes from "./FormBuilderCustom.css";
import SignatureCanvas from "react-signature-canvas";
import { withNamespaces } from "react-i18next";
import { Controlled as CodeMirror } from "react-codemirror2";
const timezones = require('../../utils/timezones.json');

const { Option } = Select;

const DragHandle = SortableHandle(({ fieldName }) => (
  <span tabIndex={0} className={classes.dragHandler}>
    <Icon
      type="drag"
      tabIndex={-1}
      style={{ fontSize: "18px", margin: "-1px 6px 0 10px" }}
    />
    <Tooltip placement="topLeft" title="Field Name">
      <Badge
        count={fieldName || "Text"}
        style={{ backgroundColor: fieldName ? "#2db7f5" : "#87d068" }}
      />
    </Tooltip>
  </span>
));

const SortableItem = SortableElement(({ value, ...props }) => {
  const { getFieldValue, getFieldsValue, getFieldDecorator } = props.form;

  const { initialValues, itemKey, editId, setEdit, errors, sectionKey } = props;

  const conditions = getFieldValue(
    `values[${sectionKey}].fields[${itemKey}].conditions`
  );
  const hardValidation = getFieldValue(
    `values[${sectionKey}].fields[${itemKey}].hardValidation`
  );
  const softValidation = getFieldValue(
    `values[${sectionKey}].fields[${itemKey}].softValidation`
  );

  return (
    <div
      className={classNames(classes.draggableItem, {
        [classes.selected]: editId === itemKey,
        [classes.error]: errors.includes(itemKey),
        [classes.draggableItemHalf]:
          getFieldValue(`values[${sectionKey}].fields[${itemKey}].column`) ===
          "1/2",
        [classes.draggableItemThird]:
          getFieldValue(`values[${sectionKey}].fields[${itemKey}].column`) ===
          "1/3",
      })}
    >
      <div className={classes.draggableItemInner}>
        <Row gutter={8}>
          <Col span={20}>
            <div className={classes.draggableItemHeading}>
              <div className={classes.draggableItemHeadingWrapper}>
                <DragHandle
                  fieldName={getFieldValue(
                    `values[${sectionKey}].fields[${itemKey}].fieldName`
                  )}
                />

                <div className={classes.formWrapperFormHeadingInputColSize}>
                  {getFieldDecorator(
                    `values[${sectionKey}].fields[${itemKey}].column`,
                    {
                      initialValue: get(
                        initialValues,
                        `${sectionKey}.fields[${itemKey}].column`,
                        "1"
                      ),
                    }
                  )(
                    <Radio.Group size="small">
                      <Radio.Button value="1">&nbsp;1&nbsp;</Radio.Button>
                      <Radio.Button value="1/2">1/2</Radio.Button>
                      <Radio.Button value="1/3">1/3</Radio.Button>
                    </Radio.Group>
                  )}
                </div>
              </div>

              <div style={{ flex: "1", marginLeft: "12px" }}>
                <div>
                  {getFieldValue(
                    `values[${sectionKey}].fields[${itemKey}].label`
                  )}{" "}
                  {getFieldValue(
                    `values[${sectionKey}].fields[${itemKey}].isRequired`
                  ) ? (
                    <span className={classes.draggableItemRequired}>*</span>
                  ) : (
                    ""
                  )}
                  <Badge
                    count={getFieldValue(
                      `values[${sectionKey}].fields[${itemKey}].type`
                    )}
                    style={{ backgroundColor: "#ccc", margin: "-6px 0 0 3px" }}
                  />
                </div>
                {getFieldValue(
                  `values[${sectionKey}].fields[${itemKey}].type`
                ) === "Text" && (
                  <p>
                    {getFieldValue(
                      `values[${sectionKey}].fields[${itemKey}].text`
                    )}
                  </p>
                )}
                {getFieldValue(
                  `values[${sectionKey}].fields[${itemKey}].type`
                ) === "InputNumber" && (
                  <InputNumber
                    placeholder={getFieldValue(
                      `values[${sectionKey}].fields[${itemKey}].placeholder`
                    )}
                  />
                )}
                {getFieldValue(
                  `values[${sectionKey}].fields[${itemKey}].type`
                ) === "AgeFromField" && (
                  <InputNumber
                    placeholder={getFieldValue(
                      `values[${sectionKey}].fields[${itemKey}].placeholder`
                    )}
                  />
                )}
                {getFieldValue(
                  `values[${sectionKey}].fields[${itemKey}].type`
                ) === "InputCheckbox" && (
                  <Checkbox>
                    {getFieldValue(
                      `values[${sectionKey}].fields[${itemKey}].placeholder`
                    )}
                  </Checkbox>
                )}

                {getFieldValue(
                  `values[${sectionKey}].fields[${itemKey}].type`
                ) === "InputDateTimepicker" && (
                  <DatePicker
                    format="YYYY/MM/DD HH:mm"
                    showTime={{ format: "HH:mm" }}
                  />
                )}

                {getFieldValue(
                  `values[${sectionKey}].fields[${itemKey}].type`
                ) === "InputDatePicker" && <DatePicker format="YYYY/MM/DD" />}

                {getFieldValue(
                  `values[${sectionKey}].fields[${itemKey}].type`
                ) === "InputSlider" && (
                  <div
                    style={{
                      height: getFieldValue(
                        `values[${sectionKey}].fields[${itemKey}].isSliderVertical`
                      )
                        ? "200px"
                        : "auto",
                    }}
                  >
                    <Slider
                      type="number"
                      min={
                        +getFieldValue(
                          `values[${sectionKey}].fields[${itemKey}].min`
                        )
                      }
                      max={
                        +getFieldValue(
                          `values[${sectionKey}].fields[${itemKey}].max`
                        )
                      }
                      vertical={getFieldValue(
                        `values[${sectionKey}].fields[${itemKey}].isSliderVertical`
                      )}
                      marks={(() => {
                        const marksObj = {};
                        const marks = getFieldValue(
                          `values[${sectionKey}].fields[${itemKey}].marks`
                        );

                        if (marks) {
                          try {
                            forEach(marks.split(","), (opt) => {
                              const option = opt.split(":");
                              if (option[0] && option[1]) {
                                marksObj[option[0].trim()] = option[1];
                              }
                            });
                          } catch (e) {}
                        }
                        return marksObj;
                      })()}
                    />
                  </div>
                )}

                {getFieldValue(
                  `values[${sectionKey}].fields[${itemKey}].type`
                ) === "InputText" && (
                  <Input
                    placeholder={getFieldValue(
                      `values[${sectionKey}].fields[${itemKey}].placeholder`
                    )}
                  />
                )}

                {getFieldValue(
                  `values[${sectionKey}].fields[${itemKey}].type`
                ) === "InputEmail" && (
                  <Input
                    placeholder={getFieldValue(
                      `values[${sectionKey}].fields[${itemKey}].placeholder`
                    )}
                  />
                )}

                {getFieldValue(
                  `values[${sectionKey}].fields[${itemKey}].type`
                ) === "InputSecureText" && (
                  <Input.Password
                    placeholder={getFieldValue(
                      `values[${sectionKey}].fields[${itemKey}].placeholder`
                    )}
                  />
                )}

                {getFieldValue(
                  `values[${sectionKey}].fields[${itemKey}].type`
                ) === "InputTextArea" && (
                  <Input.TextArea
                    placeholder={getFieldValue(
                      `values[${sectionKey}].fields[${itemKey}].placeholder`
                    )}
                  />
                )}

                {getFieldValue(
                  `values[${sectionKey}].fields[${itemKey}].type`
                ) === "HTMLBlock" && (
                  <CodeMirror
                    value='<!-- CODE /-->'
                    options={{
                      mode: "html",
                      theme: "material",
                      lineNumbers: true,
                    }}
                  />
                )}

                {getFieldValue(
                  `values[${sectionKey}].fields[${itemKey}].type`
                ) === "InputMonthPicker" && (
                  <DatePicker.MonthPicker
                    placeholder={getFieldValue(
                      `values[${sectionKey}].fields[${itemKey}].placeholder`
                    )}
                    allowClear
                  />
                )}

                {getFieldValue(
                  `values[${sectionKey}].fields[${itemKey}].type`
                ) === "InputTimePicker" && (
                  <TimePicker
                    placeholder={getFieldValue(
                      `values[${sectionKey}].fields[${itemKey}].placeholder`
                    )}
                    format="HH:mm"
                    showToday={false}
                    allowClear
                  />
                )}

                {getFieldValue(
                  `values[${sectionKey}].fields[${itemKey}].type`
                ) === "InputSignature" && (
                  <SignatureCanvas
                    clearOnResize={false}
                    penColor="black"
                    canvasProps={{
                      width: 180,
                      height: 100,
                      className: "sig-canvas",
                    }}
                  />
                )}

                {getFieldValue(
                  `values[${sectionKey}].fields[${itemKey}].type`
                ) === "InputUpload" && (
                  <Upload
                    accept=".doc,.docx,.odt,.txt,.xls,.xlsx,.ppt,.pptx,.pdf,.png,.jpg,.jpeg,.gif,.mp4"
                    action=""
                    beforeUpload={() => false}
                    multiple={false}
                  >
                    <Button>
                      <Icon type="upload" />
                      {props.i18n.t("Change file")}
                    </Button>
                  </Upload>
                )}

                {getFieldValue(
                  `values[${sectionKey}].fields[${itemKey}].type`
                ) === "InputSelectSiteID" && (
                  <Select
                    style={{ width: "100%" }}
                    placeholder={getFieldValue(
                      `values[${sectionKey}].fields[${itemKey}].placeholder`
                    )}
                  >
                    <Option value="site1">Example Site 1</Option>
                    <Option value="site2">Example Site 2</Option>
                  </Select>
                )}

                {getFieldValue(
                  `values[${sectionKey}].fields[${itemKey}].type`
                ) === "InputSelectFollowUpID" && (
                  <Select
                    style={{ width: "100%" }}
                    placeholder={getFieldValue(
                      `values[${sectionKey}].fields[${itemKey}].placeholder`
                    )}
                  >
                    <Option value="site1">Follow-up 24 hours</Option>
                    <Option value="site2">Follow-up 7 days</Option>
                  </Select>
                )}

                {getFieldValue(
                  `values[${sectionKey}].fields[${itemKey}].type`
                ) === "InputSelectUserID" && (
                  <Select
                    style={{ width: "100%" }}
                    placeholder={getFieldValue(
                      `values[${sectionKey}].fields[${itemKey}].placeholder`
                    )}
                  >
                    <Option value="user1">Example User 1</Option>
                    <Option value="user2">Example User 2</Option>
                  </Select>
                )}

                {getFieldValue(
                  `values[${sectionKey}].fields[${itemKey}].type`
                ) === "InputTimezone" && (
                  <Select
                    style={{ width: "100%" }}
                    placeholder={getFieldValue(
                      `values[${sectionKey}].fields[${itemKey}].placeholder`
                    )}
                  >
                    <Option value="">None</Option>
                    {timezones.map(({ utc }) => utc.map((tz, i) => (
                      <Option value={tz} key={i}>{tz}</Option>
                    )))}
                  </Select>
                )}

                {getFieldValue(
                  `values[${sectionKey}].fields[${itemKey}].type`
                ) === "InputSelect" && (
                  <Select
                    style={{ width: "100%" }}
                    placeholder={getFieldValue(
                      `values[${sectionKey}].fields[${itemKey}].placeholder`
                    )}
                  >
                    {getFieldValue(
                      `values[${sectionKey}].fields[${itemKey}].options`
                    ) &&
                      map(
                        getFieldValue(
                          `values[${sectionKey}].fields[${itemKey}].options`
                        ).split(","),
                        (opt, i) => (
                          <Option value={opt.split(":")[0]} key={i}>
                            {opt.split(":")[1]}
                          </Option>
                        )
                      )}
                  </Select>
                )}

                {getFieldValue(
                  `values[${sectionKey}].fields[${itemKey}].type`
                ) === "InputRadioGroup" && (
                  <Radio.Group>
                    {getFieldValue(
                      `values[${sectionKey}].fields[${itemKey}].options`
                    ) &&
                      map(
                        getFieldValue(
                          `values[${sectionKey}].fields[${itemKey}].options`
                        ).split(","),
                        (opt, i) => (
                          <div key={i}>
                            <Radio value={opt.split(":")[0]}>
                              {opt.split(":")[1]}
                            </Radio>
                          </div>
                        )
                      )}
                  </Radio.Group>
                )}

                {getFieldValue(
                  `values[${sectionKey}].fields[${itemKey}].type`
                ) === "InputRadioBooleanGroup" && (
                  <Radio.Group>
                    {getFieldValue(
                      `values[${sectionKey}].fields[${itemKey}].options`
                    ) &&
                      map(
                        getFieldValue(
                          `values[${sectionKey}].fields[${itemKey}].options`
                        ).split(","),
                        (opt, i) => (
                          <div key={i}>
                            <Radio value={opt.split(":")[0]}>
                              {opt.split(":")[1]}
                            </Radio>
                          </div>
                        )
                      )}
                  </Radio.Group>
                )}

                {getFieldValue(
                  `values[${sectionKey}].fields[${itemKey}].type`
                ) === "InputCheckboxGroup" && (
                  <Checkbox.Group
                    options={
                      getFieldValue(
                        `values[${sectionKey}].fields[${itemKey}].options`
                      )
                        ? map(
                            getFieldValue(
                              `values[${sectionKey}].fields[${itemKey}].options`
                            ).split(","),
                            (opt, i) => ({
                              label: opt.split(":")[1],
                              value: opt.split(":")[0],
                            })
                          )
                        : []
                    }
                  />
                )}
              </div>
            </div>

            {getFieldValue(
              `values[${sectionKey}].fields[${itemKey}].conditions`
            ) && (
              <div style={{ margin: "0 0 10px 14px" }}>
                Conditions:
                <Alert
                  message={map(Object.keys(conditions), (groupKey, i) => (
                    <div className={classes.conditionsView} key={groupKey}>
                      {i > 0 && (
                        <div>
                          <b>OR</b>
                        </div>
                      )}
                      {map(
                        Object.keys(conditions[groupKey]),
                        (conditionKey) => (
                          <div key={conditionKey}>
                            {get(
                              conditions,
                              `${groupKey}.${conditionKey}.fieldName`
                            )}
                            &nbsp;
                            <b>
                              {get(
                                conditions,
                                `${groupKey}.${conditionKey}.operator`
                              )}
                            </b>
                            &nbsp;
                            {get(
                              conditions,
                              `${groupKey}.${conditionKey}.value`
                            )}
                          </div>
                        )
                      )}
                    </div>
                  ))}
                  type="warning"
                />
              </div>
            )}

            {getFieldValue(
              `values[${sectionKey}].fields[${itemKey}].hardValidation`
            ) && (
              <div style={{ margin: "0 0 10px 14px" }}>
                Hard Validations:
                <Alert
                  message={map(Object.keys(hardValidation), (groupKey, i) => (
                    <div className={classes.conditionsView} key={groupKey}>
                      {i > 0 && (
                        <div>
                          <b>OR</b>
                        </div>
                      )}
                      {map(
                        Object.keys(hardValidation[groupKey]),
                        (conditionKey) => (
                          <div key={conditionKey}>
                            <b>
                              {get(
                                hardValidation,
                                `${groupKey}.${conditionKey}.operator`
                              )}
                            </b>
                            &nbsp;
                            {get(
                              hardValidation,
                              `${groupKey}.${conditionKey}.value`
                            )}
                          </div>
                        )
                      )}
                    </div>
                  ))}
                  type="warning"
                />
              </div>
            )}
          </Col>

          <Col span={4}>
            <div className={classes.draggableItemInnerEdit}>
              {!props.editDisabled && (
                <Icon
                  style={{ margin: "3px 0 5px 0", color: "#f00" }}
                  type="delete"
                  onClick={props.onDeleteItem(itemKey, sectionKey)}
                />
              )}

              <Button
                disabled={props.editDisabled}
                size="small"
                type="dashed"
                style={{ marginTop: "-1px" }}
                onClick={() => {
                  setEdit(editId === itemKey ? null : itemKey);
                }}
              >
                {editId === itemKey ? "Done" : "Edit"}
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
});

const SortableList = SortableContainer(({ ...props }) => {
  return (
    <div className={classes.sortableList}>
      {map(props.keys, (itemKey, index) => (
        <SortableItem
          key={itemKey}
          itemKey={itemKey}
          index={index}
          collection={props.sectionKey}
          {...props}
        />
      ))}
    </div>
  );
});

class FormBuilderCustom extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      sectionKeys: [],
      sectionFieldsKeys: {},
      conditionGroupKeys: {},
      conditionKeys: {},
      conditionRequiredGroupKeys: {},
      conditionRequiredKeys: {},
      conditionHardValidationGroupKeys: {},
      conditionHardValidationKeys: {},
      conditionSoftValidationGroupKeys: {},
      conditionSoftValidationKeys: {},
      editId: null,
      formValues: null,
      errors: [],
      fieldNames: [],
      conditionType: "conditions",
    };
  }

  componentDidMount() {
    if (this.props.initialValues) {
      const initialValues = this.props.initialValues;
      const sectionFieldsKeys = {};
      const conditionKeys = {};
      const conditionGroupKeys = {};
      const conditionRequiredKeys = {};
      const conditionRequiredGroupKeys = {};
      const conditionHardValidationKeys = {};
      const conditionHardValidationGroupKeys = {};
      const conditionSoftValidationKeys = {};
      const conditionSoftValidationGroupKeys = {};

      const sectionKeys = Object.keys(initialValues).sort(
        (a, b) => initialValues[a].order - initialValues[b].order
      );

      forEach(sectionKeys, (sectionKey) => {
        sectionFieldsKeys[sectionKey] = Object.keys(
          initialValues[sectionKey].fields || {}
        ).sort(
          (a, b) =>
            initialValues[sectionKey].fields[a].order -
            initialValues[sectionKey].fields[b].order
        );

        const initialValuesSection = initialValues[sectionKey].fields || {};

        Object.keys(initialValuesSection).map((itemKey) => {
          if (initialValuesSection[itemKey].conditions) {
            conditionGroupKeys[itemKey] = Object.keys(
              initialValuesSection[itemKey].conditions
            );

            forEach(conditionGroupKeys[itemKey], (conditionKey) => {
              conditionKeys[conditionKey] = Object.keys(
                initialValuesSection[itemKey].conditions[conditionKey]
              );
            });
          }

          if (initialValuesSection[itemKey].conditionsRequired) {
            conditionRequiredGroupKeys[itemKey] = Object.keys(
              initialValuesSection[itemKey].conditionsRequired
            );

            forEach(conditionRequiredGroupKeys[itemKey], (conditionKey) => {
              conditionRequiredKeys[conditionKey] = Object.keys(
                initialValuesSection[itemKey].conditionsRequired[conditionKey]
              );
            });
          }

          if (initialValuesSection[itemKey].hardValidation) {
            conditionHardValidationGroupKeys[itemKey] = Object.keys(
              initialValuesSection[itemKey].hardValidation
            );

            forEach(
              conditionHardValidationGroupKeys[itemKey],
              (conditionKey) => {
                conditionHardValidationKeys[conditionKey] = Object.keys(
                  initialValuesSection[itemKey].hardValidation[conditionKey]
                );
              }
            );
          }

          if (initialValuesSection[itemKey].softValidation) {
            conditionSoftValidationGroupKeys[itemKey] = Object.keys(
              initialValuesSection[itemKey].softValidation
            );

            forEach(
              conditionSoftValidationGroupKeys[itemKey],
              (conditionKey) => {
                conditionSoftValidationKeys[conditionKey] = Object.keys(
                  initialValuesSection[itemKey].softValidation[conditionKey]
                );
              }
            );
          }
        });
      });

      this.setState(
        {
          sectionKeys,
          sectionFieldsKeys,
          conditionGroupKeys,
          conditionKeys,
          conditionRequiredGroupKeys,
          conditionRequiredKeys,
          conditionHardValidationGroupKeys,
          conditionHardValidationKeys,
          conditionSoftValidationGroupKeys,
          conditionSoftValidationKeys,
          editId: sectionFieldsKeys[sectionKeys[0]][0],
        },
        () => {
          this.setState({
            editId: null,
            formValues: this.props.form.getFieldsValue(),
          });
        }
      );
    }
  }

  validateErrors = (err) => {
    if (!err) {
      this.setState({ errors: [] });

      this.props.form.validateFields(async (err) => {
        if (err && err.values) {
          this.setState({
            errors: flatten(
              map(Object.keys(err.values), (sectionKey) =>
                Object.keys(get(err, `values[${sectionKey}].fields`))
              )
            ),
          });
        } else {
          this.setState({ errors: [] });
        }
      });
    } else {
      this.setState({
        errors: flatten(
          map(Object.keys(get(err, "values", {})), (sectionKey) =>
            Object.keys(get(err, `values[${sectionKey}].fields`))
          )
        ),
      });
    }
  };

  setEdit = (editId) => {
    this.validateErrors();
    this.setState({ editId });
    this.setFieldNames();
  };

  onSortEnd = ({ oldIndex, newIndex, collection }) => {
    this.setState(({ sectionFieldsKeys }) => ({
      sectionFieldsKeys: {
        ...sectionFieldsKeys,
        [collection]: arrayMove(
          sectionFieldsKeys[collection],
          oldIndex,
          newIndex
        ),
      },
    }));
  };

  handleSubmit = (type) => (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, data) => {
      if (!err) {
        const values = { ...data.values };
        forEach(Object.keys(values), (sectionKey) => {
          const order = this.state.sectionKeys.indexOf(sectionKey);
          if (~order) {
            values[sectionKey].order = order;
          }

          forEach(
            Object.keys(get(values, `${sectionKey}.fields`, {})),
            (key) => {
              const order = this.state.sectionFieldsKeys[sectionKey].indexOf(
                key
              );
              if (~order) {
                values[sectionKey].fields[key].order = order;
              }

              if (values[sectionKey].fields[key].min === "") {
                values[sectionKey].fields[key].min = null;
              }

              if (values[sectionKey].fields[key].max === "") {
                values[sectionKey].fields[key].max = null;
              }
            }
          );
        });

        delete values[0];

        if (type === "onPreview") {
          this.props.onPreview(values, data.name);
        } else if (type === 'onSchemaEdit') {
          this.props.onSchemaEdit(values, data.name);
        } else {
          this.props.onSubmit({
            schema: values,
            name: data.name,
            slug: data.name.trim().replace(/ /g, "_").toLowerCase(),
          });
        }
      } else {
        if (type === "onPreview" || type === "onSchemaEdit") {
          notification.error({
            message: "Error",
            description: "Please check fields",
          });
        }
      }
    });
  };

  onAddSection = () => {
    this.props.form.validateFields(async (err) => {
      if (!(err && err.values)) {
        const id = uuidv4();
        this.setState((state) => ({
          sectionKeys: [...state.sectionKeys, id],
          sectionFieldsKeys: { ...state.sectionFieldsKeys, [id]: [] },
          editId: id,
        }));
      } else {
        this.validateErrors(err);
      }
    });
  };

  onDeleteSection = (sectionKey) => () => {
    this.setState(
      (state) => {
        const sectionFieldsKeys = { ...state.sectionFieldsKeys };
        forEach(sectionFieldsKeys[sectionKey], (fieldKey) => {
          this.onDeleteItem(fieldKey, sectionKey)();
        });

        delete sectionFieldsKeys[sectionKey];

        const sectionKeys = state.sectionKeys
          ? [...state.sectionKeys.filter((k) => sectionKey !== k)]
          : [];

        return {
          sectionKeys,
          sectionFieldsKeys,
        };
      },
      () => {
        this.validateErrors();
      }
    );
  };

  onAddItem = (sectionKey) => {
    this.props.form.validateFields(async (err) => {
      if (!(err && err.values)) {
        const id = uuidv4();
        this.setState((state) => ({
          sectionFieldsKeys: {
            ...state.sectionFieldsKeys,
            [sectionKey]: [...state.sectionFieldsKeys[sectionKey], id],
          },
        }));

        this.setEdit(id);
      } else {
        this.validateErrors(err);
      }
    });
  };

  onDeleteItem = (key, sectionKey) => () => {
    this.setState(
      (state) => {
        const conditionGroupKeys = { ...state.conditionGroupKeys };
        const conditionKeys = { ...state.conditionKeys };
        const conditionRequiredGroupKeys = {
          ...state.conditionRequiredGroupKeys,
        };
        const conditionRequiredKeys = { ...state.conditionRequiredKeys };
        const conditionHardValidationGroupKeys = {
          ...state.conditionHardValidationGroupKeys,
        };
        const conditionHardValidationKeys = {
          ...state.conditionHardValidationKeys,
        };

        const conditionSoftValidationGroupKeys = {
          ...state.conditionSoftValidationGroupKeys,
        };
        const conditionSoftValidationKeys = {
          ...state.conditionSoftValidationKeys,
        };

        forEach(conditionHardValidationGroupKeys[key], (groupKey) => {
          delete conditionHardValidationKeys[groupKey];
        });
        forEach(conditionSoftValidationGroupKeys[key], (groupKey) => {
          delete conditionSoftValidationKeys[groupKey];
        });
        forEach(conditionGroupKeys[key], (groupKey) => {
          delete conditionKeys[groupKey];
        });
        forEach(conditionRequiredGroupKeys[key], (groupKey) => {
          delete conditionRequiredKeys[groupKey];
        });

        delete conditionGroupKeys[key];
        delete conditionRequiredGroupKeys[key];
        delete conditionHardValidationGroupKeys[key];
        delete conditionSoftValidationGroupKeys[key];

        const sectionFieldKeys = state.sectionFieldsKeys[sectionKey];
        const sectionFieldsKeys = sectionFieldKeys
          ? {
              ...state.sectionFieldsKeys,
              [sectionKey]: [...sectionFieldKeys.filter((k) => key !== k)],
            }
          : state.sectionFieldsKeys;

        return {
          conditionKeys,
          conditionGroupKeys,
          conditionRequiredKeys,
          conditionRequiredGroupKeys,
          conditionHardValidationKeys,
          conditionHardValidationGroupKeys,
          conditionSoftValidationKeys,
          conditionSoftValidationGroupKeys,
          sectionFieldsKeys,
        };
      },
      () => {
        this.validateErrors();
      }
    );
  };

  onAddConditionGroup = (key, groupKeys) => () => {
    this.setState((state) => {
      return {
        [groupKeys]: {
          ...state[groupKeys],
          [key]: state[groupKeys][key]
            ? [...state[groupKeys][key], uuidv4()]
            : [uuidv4()],
        },
      };
    });

    this.validateErrors();
  };

  onDeleteConditionGroup = (
    key,
    conditionGroupKey,
    conditionKeysName,
    conditionGroupKeysName
  ) => () => {
    this.setState((state) => {
      const conditionKeys = { ...state[conditionKeysName] };
      delete conditionKeys[conditionGroupKey];

      return {
        [conditionGroupKeysName]: {
          ...state[conditionGroupKeysName],
          [key]: state[conditionGroupKeysName][key].filter(
            (k) => conditionGroupKey !== k
          ),
        },
        [conditionKeysName]: conditionKeys,
      };
    });

    this.validateErrors();
  };

  onAddCondition = (key, conditionKeysName) => () => {
    this.setState((state) => {
      return {
        [conditionKeysName]: {
          ...state[conditionKeysName],
          [key]: state[conditionKeysName][key]
            ? [...state[conditionKeysName][key], uuidv4()]
            : [uuidv4()],
        },
      };
    });

    this.validateErrors();
  };

  onDeleteCondition = (key, conditionKey, conditionKeysName) => () => {
    this.setState(
      (state) => ({
        [conditionKeysName]: {
          ...state[conditionKeysName],
          [key]: state[conditionKeysName][key].filter(
            (k) => conditionKey !== k
          ),
        },
      }),
      () => {
        this.validateErrors();
      }
    );
  };

  sectionUp = (sectionKey, index) => {
    this.setState(({ sectionKeys }) => ({
      sectionKeys: arrayMove(sectionKeys, index, index - 1),
    }));
  };

  sectionDown = (sectionKey, index) => {
    this.setState(({ sectionKeys }) => ({
      sectionKeys: arrayMove(sectionKeys, index, index + 1),
    }));
  };

  conditionBlock = ({
    conditionType,
    sectionKey,
    fieldNames,
    conditionKeys,
    getFieldValue,
    getFieldDecorator,
    conditionGroupKeys,
    itemKey,
    conditionName,
    conditionKeysName,
    conditionGroupKeysName,
  }) => {
    return (
      <div>
        {map(conditionGroupKeys[itemKey], (conditionGroupKey, i) => (
          <div key={conditionGroupKey} className={classes.conditionGroup}>
            {i > 0 && <div className={classes.conditionOr}>OR</div>}
            <h6 className={classes.conditionsHeader}>
              {["hardValidation", "softValidation"].includes(conditionType)
                ? "Validation"
                : "Condition"}{" "}
              Group: &nbsp; &nbsp;
              <Icon
                style={{ color: "#f00" }}
                type="minus-circle-o"
                onClick={this.onDeleteConditionGroup(
                  itemKey,
                  conditionGroupKey,
                  conditionKeysName,
                  conditionGroupKeysName
                )}
              />
            </h6>

            {map(conditionKeys[conditionGroupKey], (conditionKey, i) => (
              <div key={conditionKey}>
                {this.conditionItem({
                  conditionType,
                  initialValues: this.props.initialValues,
                  sectionKey,
                  itemKey,
                  conditionGroupKey,
                  conditionKey,
                  fieldNames,
                  getFieldValue,
                  getFieldDecorator,
                  onDeleteCondition: this.onDeleteCondition,
                  conditionName,
                  conditionKeysName,
                })}
              </div>
            ))}

            <Row gutter={8}>
              <Col>
                <Button
                  type="dashed"
                  htmlType="button"
                  size="small"
                  onClick={this.onAddCondition(
                    conditionGroupKey,
                    conditionKeysName
                  )}
                >
                  Add condition
                </Button>
              </Col>
            </Row>
          </div>
        ))}
        {(!["hardValidation", "softValidation"].includes(conditionType) ||
          !conditionGroupKeys[itemKey] ||
          (conditionGroupKeys[itemKey] &&
            conditionGroupKeys[itemKey].length === 0)) && (
          <Row gutter={8}>
            <Col>
              <Button
                type="dashed"
                htmlType="button"
                size="small"
                onClick={this.onAddConditionGroup(
                  itemKey,
                  conditionGroupKeysName
                )}
              >
                Add condition group
              </Button>
            </Col>
          </Row>
        )}
      </div>
    );
  };

  conditionItem = ({
    conditionType,
    initialValues,
    sectionKey,
    itemKey,
    conditionGroupKey,
    conditionKey,
    fieldNames,
    getFieldValue,
    getFieldDecorator,
    onDeleteCondition,
    conditionName,
    conditionKeysName,
  }) => {
    return (
      <Row gutter={8}>
        <Col span={8}>
          <span>Field name:</span>
          <Form.Item>
            {getFieldDecorator(
              `values[${sectionKey}].fields[${itemKey}].${conditionName}[${conditionGroupKey}][${conditionKey}].fieldName`,
              {
                rules: [
                  {
                    required: true,
                    message: "Required",
                  },
                ],
                initialValue: ["hardValidation", "softValidation"].includes(
                  conditionType
                )
                  ? getFieldValue(
                      `values[${sectionKey}].fields[${itemKey}].fieldName`
                    )
                  : get(
                      initialValues,
                      `${sectionKey}.fields.${itemKey}.${conditionName}[${conditionGroupKey}][${conditionKey}].fieldName`
                    ),
              }
            )(
              <Select
                style={{ width: "100%" }}
                disabled={["hardValidation", "softValidation"].includes(
                  conditionType
                )}
              >
                {["hardValidation", "softValidation"].includes(
                  conditionType
                ) ? (
                  <Option
                    value={getFieldValue(
                      `values[${sectionKey}].fields[${itemKey}].fieldName`
                    )}
                    key={getFieldValue(
                      `values[${sectionKey}].fields[${itemKey}].fieldName`
                    )}
                  >
                    {getFieldValue(
                      `values[${sectionKey}].fields[${itemKey}].fieldName`
                    )}
                  </Option>
                ) : (
                  map(
                    fieldNames.filter(
                      (fieldName) =>
                        fieldName !==
                        getFieldValue(
                          `values[${sectionKey}].fields[${itemKey}].fieldName`
                        )
                    ),
                    (fieldName) => (
                      <Option value={fieldName} key={fieldName}>
                        {fieldName}
                      </Option>
                    )
                  )
                )}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={10}>
          <span>Operator:</span>
          <Form.Item>
            {getFieldDecorator(
              `values[${sectionKey}].fields[${itemKey}].${conditionName}[${conditionGroupKey}][${conditionKey}].operator`,
              {
                rules: [
                  {
                    required: true,
                    message: "Required",
                  },
                ],
                initialValue: get(
                  initialValues,
                  `${sectionKey}.fields.${itemKey}.${conditionName}[${conditionGroupKey}][${conditionKey}].operator`
                ),
              }
            )(
              <Select style={{ width: "100%" }}>
                {!["hardValidation"].includes(conditionType) && (
                  <Option value="notEmpty">Not empty</Option>
                )}
                {!["hardValidation"].includes(conditionType) && (
                  <Option value="empty">Empty</Option>
                )}
                <Option value="equal">Equal</Option>
                <Option value="gte">Greater or equal</Option>
                <Option value="lte">Lower or equal</Option>
              </Select>
            )}
          </Form.Item>
        </Col>
        {["equal", "gte", "lte"].includes(
          getFieldValue(
            `values[${sectionKey}].fields[${itemKey}].${conditionName}[${conditionGroupKey}][${conditionKey}].operator`
          )
        ) && (
          <Col span={5}>
            <span>Value:</span>
            <Form.Item>
              {getFieldDecorator(
                `values[${sectionKey}].fields[${itemKey}].${conditionName}[${conditionGroupKey}][${conditionKey}].value`,
                {
                  rules: [
                    {
                      required: true,
                      message: "Required",
                    },
                  ],
                  initialValue: get(
                    initialValues,
                    `${sectionKey}.fields.${itemKey}.${conditionName}[${conditionGroupKey}][${conditionKey}].value`
                  ),
                }
              )(
                <Input
                  placeholder={
                    ["hardValidation"].includes(conditionType) &&
                    "value1,value2"
                  }
                />
              )}
            </Form.Item>
          </Col>
        )}
        <Col span={1}>
          <Icon
            style={{
              marginTop: "36px",
              color: "#f00",
            }}
            type="minus-circle-o"
            onClick={onDeleteCondition(
              conditionGroupKey,
              conditionKey,
              conditionKeysName
            )}
          />
        </Col>
      </Row>
    );
  };

  setFieldNames = () => {
    const fieldNames = this.getFieldNames();

    this.setState({ fieldNames });
  };

  getFieldNames = () => {
    const { getFieldsValue } = this.props.form;
    const formValues = getFieldsValue();

    if (formValues && formValues.values) {
      const sectionFormKeys = Object.keys(formValues.values);
      return flatten(
        map(sectionFormKeys, (sectionFormKey) =>
          map(
            Object.keys(
              get(formValues, `values[${sectionFormKey}].fields`, {})
            ),
            (k) => formValues.values[sectionFormKey].fields[k].fieldName
          ).filter((v) => v)
        )
      );
    }
    return [];
  };

  getFields = () => {
    const { getFieldsValue } = this.props.form;
    const formValues = getFieldsValue();

    if (formValues && formValues.values) {
      const sectionFormKeys = Object.keys(formValues.values);
      return flatten(
        map(sectionFormKeys, (sectionFormKey) =>
          map(
            Object.keys(
              get(formValues, `values[${sectionFormKey}].fields`, {})
            ),
            (k) => formValues.values[sectionFormKey].fields[k]
          ).filter((v) => v)
        )
      );
    }
    return [];
  };

  render() {
    const {
      sectionKeys,
      sectionFieldsKeys,
      conditionKeys,
      conditionGroupKeys,
      conditionRequiredGroupKeys,
      conditionHardValidationKeys,
      conditionHardValidationGroupKeys,
      conditionSoftValidationKeys,
      conditionSoftValidationGroupKeys,
      conditionRequiredKeys,
      editId,
      errors,
      conditionType,
      fieldNames,
      formValues,
    } = this.state;

    const { initialValues } = this.props;

    const {
      getFieldsValue,
      getFieldValue,
      getFieldDecorator,
    } = this.props.form;

    return (
      <div className={classes.formBuilder}>
        <Form onSubmit={this.handleSubmit()}>
          <div className={classes.formWrapper}>
            <div className={classes.formWrapperForm}>
              <Row>
                <Col span={12}>
                  <Form.Item label="Form Name">
                    {getFieldDecorator(`name`, {
                      rules: [{ required: true, message: "Required" }],
                      initialValue: this.props.name || "",
                    })(
                      <Input
                        disabled={!!this.props.name}
                        size="large"
                        placeholder="e.g. Follow Up"
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={8} type="flex">
                {map(sectionKeys, (sectionKey, i) => (
                  <Col
                    key={sectionKey}
                    span={
                      get(formValues, `values[${sectionKey}].column`) === "1/2"
                        ? 12
                        : 24
                    }
                  >
                    <div
                      className={classes.formWrapperSection}
                      key={sectionKey}
                    >
                      <h4
                        className={classNames(classes.formWrapperFormHeading, {
                          [classes.selected]: editId === sectionKey,
                        })}
                      >
                        {i !== 0 && (
                          <Icon
                            type="arrow-up"
                            style={{ fontSize: "14px", marginRight: "6px" }}
                            onClick={() => this.sectionUp(sectionKey, i)}
                          />
                        )}
                        {i !== sectionKeys.length - 1 && (
                          <Icon
                            type="arrow-down"
                            style={{ fontSize: "14px", marginRight: "6px" }}
                            onClick={() => this.sectionDown(sectionKey, i)}
                          />
                        )}

                        <div className={classes.formWrapperFormHeadingTitle}>
                          {getFieldValue(
                            `values[${sectionKey}].sectionName`
                          ) || (
                            <div
                              style={{ color: "#999" }}
                            >{`Untitled Section`}</div>
                          )}
                        </div>

                        <div className={classes.formWrapperFormHeadingColSize}>
                          {getFieldDecorator(`values[${sectionKey}].column`, {
                            initialValue: get(
                              initialValues,
                              `${sectionKey}.column`,
                              "1"
                            ),
                          })(
                            <Radio.Group
                              size="small"
                              onChange={() => {
                                setTimeout(() => {
                                  this.setState({
                                    formValues: getFieldsValue(),
                                  });
                                }, 0);
                              }}
                            >
                              <Radio.Button value="1">
                                &nbsp;1&nbsp;
                              </Radio.Button>
                              <Radio.Button value="1/2">1/2</Radio.Button>
                            </Radio.Group>
                          )}
                        </div>

                        <div className={classes.formWrapperFormHeadingRight}>
                          <Button
                            size="small"
                            type="dashed"
                            disabled={this.props.editDisabled}
                            onClick={() => {
                              this.setEdit(
                                editId === sectionKey ? null : sectionKey
                              );
                            }}
                          >
                            {editId === sectionKey ? "Done" : "Edit"}
                          </Button>

                          {!this.props.editDisabled && (
                            <Icon
                              style={{
                                margin: "3px 0 5px 12px",
                                color: "#f00",
                                fontSize: "14px",
                              }}
                              type="delete"
                              onClick={this.onDeleteSection(sectionKey)}
                            />
                          )}
                        </div>
                      </h4>
                      <SortableList
                        initialValues={initialValues}
                        helperClass="form-builder-sorting"
                        useDragHandle={true}
                        // lockAxis="y"
                        axis="xy"
                        sectionKey={sectionKey}
                        keys={sectionFieldsKeys[sectionKey]}
                        conditionGroupKeys={conditionGroupKeys}
                        conditionKeys={conditionKeys}
                        setEdit={this.setEdit}
                        editId={editId}
                        errors={errors}
                        onDeleteItem={this.onDeleteItem}
                        onAddCondition={this.onAddCondition}
                        onDeleteCondition={this.onDeleteCondition}
                        onAddConditionGroup={this.onAddConditionGroup}
                        onDeleteConditionGroup={this.onDeleteConditionGroup}
                        onSortEnd={this.onSortEnd}
                        fieldNames={fieldNames}
                        {...this.props}
                      />

                      <div className={classes.addItem}>
                        <Button
                          type="dashed"
                          htmlType="button"
                          size="small"
                          onClick={() => this.onAddItem(sectionKey)}
                        >
                          Add input
                        </Button>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>

              <div className={classes.addSection}>
                <Button
                  type="dashed"
                  htmlType="button"
                  size="small"
                  disabled={this.props.editDisabled}
                  onClick={this.onAddSection}
                >
                  Add section
                </Button>
              </div>

              <div className={classes.formBuilderSave}>
                {errors.length > 0 && (
                  <div className={classes.errorWrapper}>
                    <Alert message="Error. Please check fields." type="error" />
                  </div>
                )}

                <div className={classes.formBuilderActions}>
                  <Button
                    type="secondary"
                    htmlType="button"
                    onClick={this.handleSubmit("onPreview")}
                  >
                    Preview
                  </Button>
                  &nbsp;
                  <Button
                    type="secondary"
                    htmlType="button"
                    onClick={this.handleSubmit("onSchemaEdit")}
                  >
                    Schema edit
                  </Button>
                  &nbsp;
                  {!this.props.editDisabled && (
                    <Button type="primary" htmlType="submit">
                      Save
                    </Button>
                  )}
                </div>
              </div>
            </div>

            <div className={classes.formWrapperEdit}>
              <div className={classes.formWrapperEditContent}>
                <div className={classes.formWrapperEditContentScroll}>
                  {map(sectionKeys, (sectionKey, i) => (
                    <div
                      key={sectionKey}
                      className={classNames([
                        editId === sectionKey
                          ? classes.showEditInput
                          : classes.hideEditInput,
                      ])}
                    >
                      <h5>Edit Section</h5>

                      <Row gutter={8}>
                        <Col span={8}>
                          <span>Section Name:</span>
                          <Form.Item>
                            {getFieldDecorator(
                              `values[${sectionKey}].sectionName`,
                              {
                                initialValue: get(
                                  initialValues,
                                  `${sectionKey}.sectionName`,
                                  ""
                                ),
                              }
                            )(<Input />)}
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  ))}

                  {map(sectionKeys, (sectionKey) =>
                    map(sectionFieldsKeys[sectionKey], (itemKey, index) => (
                      <div
                        key={itemKey}
                        className={classNames([
                          editId === itemKey
                            ? classes.showEditInput
                            : classes.hideEditInput,
                        ])}
                      >
                        <h5>Edit field</h5>

                        {getFieldValue(
                          `values[${sectionKey}].fields[${itemKey}].fieldName`
                        ) && (
                          <p>
                            <Badge
                              count={`${getFieldValue(
                                `values[${sectionKey}].fields[${itemKey}].fieldName`
                              )}`}
                              style={{ backgroundColor: "#2968AE" }}
                            />
                          </p>
                        )}

                        <Row gutter={8}>
                          <Col span={8}>
                            <div className={classes.draggableItemHeading}>
                              <Form.Item>
                                {getFieldDecorator(
                                  `values[${sectionKey}].fields[${itemKey}].type`,
                                  {
                                    rules: [
                                      { required: true, message: "Required" },
                                    ],
                                    initialValue: get(
                                      initialValues,
                                      `${sectionKey}.fields.${itemKey}.type`
                                    ),
                                  }
                                )(
                                  <Select
                                    placeholder="Input type"
                                    style={{ width: "100%" }}
                                  >
                                    <Option value="InputText">
                                      Text Input
                                    </Option>
                                    <Option value="InputEmail">
                                      Email Input
                                    </Option>
                                    <Option value="InputTextArea">
                                      TextArea Input
                                    </Option>
                                    <Option value="InputNumber">Number</Option>
                                    <Option value="InputSelect">Select</Option>
                                    <Option value="InputCheckbox">
                                      Checkbox
                                    </Option>
                                    <Option value="InputRadioGroup">
                                      Radio Group
                                    </Option>
                                    <Option value="AgeFromField">Age</Option>
                                    <Option value="DateDeltaMinutesField">
                                      Date Delta Minutes
                                    </Option>
                                    <Option value="InputSlider">Slider</Option>
                                    <Option value="InputSelectSiteID">
                                      Select Site ID
                                    </Option>
                                    <Option value="InputSelectFollowUpID">
                                      Select Followup
                                    </Option>
                                    <Option value="InputSelectUserID">
                                      Select User ID
                                    </Option>
                                    <Option value="InputSignature">
                                      Signature
                                    </Option>
                                    <Option value="InputUpload">
                                      Attachment
                                    </Option>
                                    <Option value="InputDatePicker">
                                      Date Picker
                                    </Option>
                                    <Option value="InputDateTimepicker">
                                      Date-Time Picker
                                    </Option>
                                    <Option value="InputMonthPicker">
                                      Month (Year) Picker
                                    </Option>
                                    <Option value="InputTimePicker">
                                      Time Picker
                                    </Option>
                                    <Option value="Text">Text</Option>
                                    <Option value="InputTimezone">Timezone</Option>
                                    <Option value="InputSecureText">Secure Text Input</Option>
                                  </Select>
                                )}
                              </Form.Item>
                            </div>
                          </Col>
                        </Row>

                        <Row gutter={8}>
                          {getFieldValue(
                            `values[${sectionKey}].fields[${itemKey}].type`
                          ) &&
                            (getFieldValue(
                              `values[${sectionKey}].fields[${itemKey}].type`
                            ).includes("Input") ||
                              getFieldValue(
                                `values[${sectionKey}].fields[${itemKey}].type`
                              ) === "AgeFromField") && (
                              <Col span={4}>
                                <div style={{ marginTop: "-22px" }}>
                                  Is Required
                                </div>
                                <Form.Item>
                                  {getFieldDecorator(
                                    `values[${sectionKey}].fields[${itemKey}].isRequired`,
                                    {
                                      valuePropName: "checked",
                                      initialValue: get(
                                        initialValues,
                                        `${sectionKey}.fields.${itemKey}.isRequired`
                                      ),
                                    }
                                  )(<Checkbox />)}
                                </Form.Item>
                              </Col>
                            )}
                          {this.props.name === "Randomization" && (
                            <div>
                              <Col span={6}>
                                <div style={{ marginTop: "-22px" }}>
                                  Is randomization factor
                                </div>
                                <Form.Item>
                                  {getFieldDecorator(
                                    `values[${sectionKey}].fields[${itemKey}].IsRandomizationFactor`,
                                    {
                                      valuePropName: "checked",
                                      initialValue: get(
                                        initialValues,
                                        `${sectionKey}.fields.${itemKey}.IsRandomizationFactor`
                                      ),
                                    }
                                  )(<Checkbox />)}
                                </Form.Item>
                              </Col>
                              <Col span={6}>
                                <div style={{ marginTop: "-22px" }}>
                                  Unique for randomization
                                </div>
                                <Form.Item>
                                  {getFieldDecorator(
                                    `values[${sectionKey}].fields[${itemKey}].uniqueRandomizationValue`,
                                    {
                                      valuePropName: "checked",
                                      initialValue: get(
                                        initialValues,
                                        `${sectionKey}.fields.${itemKey}.uniqueRandomizationValue`
                                      ),
                                    }
                                  )(<Checkbox />)}
                                </Form.Item>
                              </Col>
                            </div>
                          )}
                          <Col span={6}>
                            <div style={{ marginTop: "-22px" }}>
                              Include in report
                            </div>
                            <Form.Item>
                              {getFieldDecorator(
                                `values[${sectionKey}].fields[${itemKey}].IncludeInReport`,
                                {
                                  valuePropName: "checked",
                                  initialValue: get(
                                    initialValues,
                                    `${sectionKey}.fields.${itemKey}.IncludeInReport`
                                  ),
                                }
                              )(<Checkbox />)}
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <div style={{ marginTop: "-22px" }}>
                              Is Disabled
                            </div>
                            <Form.Item>
                              {getFieldDecorator(
                                `values[${sectionKey}].fields[${itemKey}].disabled`,
                                {
                                  valuePropName: "checked",
                                  initialValue: get(
                                    initialValues,
                                    `${sectionKey}.fields.${itemKey}.disabled`
                                  ),
                                }
                              )(<Checkbox />)}
                            </Form.Item>
                          </Col>
                          <Col span={6}>
                            <div style={{ marginTop: "-22px" }}>
                              Is Readonly
                            </div>
                            <Form.Item>
                              {getFieldDecorator(
                                `values[${sectionKey}].fields[${itemKey}].readonly`,
                                {
                                  valuePropName: "checked",
                                  initialValue: get(
                                    initialValues,
                                    `${sectionKey}.fields.${itemKey}.readonly`
                                  ),
                                }
                              )(<Checkbox />)}
                            </Form.Item>
                          </Col>
                        </Row>

                        {["InputDateTimepicker"].includes(
                          getFieldValue(
                            `values[${sectionKey}].fields[${itemKey}].type`
                          )
                        ) && (
                          <Row gutter={8}>
                            <Col span={8}>
                              <Form.Item>
                                {getFieldDecorator(
                                  `values[${sectionKey}].fields[${itemKey}].disable_future_dates`,
                                  {
                                    valuePropName: "checked",
                                    initialValue: get(
                                      initialValues,
                                      `${sectionKey}.fields.${itemKey}.disable_future_dates`
                                    ),
                                  }
                                )(<Checkbox>Disable future dates</Checkbox>)}
                              </Form.Item>
                              <Form.Item>
                                <span>Max minutes before now:</span>
                                {getFieldDecorator(
                                  `values[${sectionKey}].fields[${itemKey}].max_minutes_before_now`,
                                  {
                                    initialValue: get(
                                      initialValues,
                                      `${sectionKey}.fields.${itemKey}.max_minutes_before_now`
                                    ),
                                  }
                                )(<InputNumber />)}
                              </Form.Item>
                            </Col>
                          </Row>
                        )}

                        {getFieldValue(
                          `values[${sectionKey}].fields[${itemKey}].type`
                        ) === "Text" && (
                          <Row gutter={8}>
                            <Col span={12}>
                              <span>Text:</span>
                              <Form.Item>
                                {getFieldDecorator(
                                  `values[${sectionKey}].fields[${itemKey}].text`,
                                  {
                                    rules: [
                                      { required: true, message: "Required" },
                                    ],
                                    initialValue: get(
                                      initialValues,
                                      `${sectionKey}.fields.${itemKey}.text`
                                    ),
                                  }
                                )(<Input.TextArea />)}
                              </Form.Item>
                            </Col>
                          </Row>
                        )}
                        {getFieldValue(
                          `values[${sectionKey}].fields[${itemKey}].type`
                        ) &&
                          (getFieldValue(
                            `values[${sectionKey}].fields[${itemKey}].type`
                          ).includes("Input") ||
                            getFieldValue(
                              `values[${sectionKey}].fields[${itemKey}].type`
                            ) === "AgeFromField" ||
                            getFieldValue(
                              `values[${sectionKey}].fields[${itemKey}].type`
                            ) === "DateDeltaMinutesField" ||
                            getFieldValue(
                              `values[${sectionKey}].fields[${itemKey}].type`
                            ) === "HTMLBlock") && (
                            <React.Fragment>
                              <Row gutter={8}>
                                <Col span={6}>
                                  <span>Field Name:</span>
                                  <Form.Item>
                                    {getFieldDecorator(
                                      `values[${sectionKey}].fields[${itemKey}].fieldName`,
                                      {
                                        trigger: "onBlur",
                                        valuePropName: "defaultValue",
                                        rules: [
                                          {
                                            validator: (
                                              rule,
                                              value,
                                              callback
                                            ) => {
                                              if (value) {
                                                try {
                                                  const map = this.getFieldNames().reduce(
                                                    (acc, e) =>
                                                      acc.set(
                                                        e,
                                                        (acc.get(e) || 0) + 1
                                                      ),
                                                    new Map()
                                                  );
                                                  if (map.get(value) > 1) {
                                                    throw new Error();
                                                  }
                                                  callback();
                                                } catch (err) {
                                                  callback(err);
                                                }
                                              } else {
                                                callback();
                                              }
                                            },
                                            message:
                                              "Field name already exists",
                                          },
                                          {
                                            required: true,
                                            message: "Required",
                                          },
                                          {
                                            pattern: /^[a-z0-9_\-]+$/,
                                            message:
                                              "Needs to contain only lowercase word characters and _",
                                          },
                                        ],
                                        initialValue: get(
                                          initialValues,
                                          `${sectionKey}.fields.${itemKey}.fieldName`
                                        ),
                                      }
                                    )(<Input />)}
                                  </Form.Item>
                                </Col>
                                <Col span={6}>
                                  <span>Label:</span>
                                  <Form.Item>
                                    {getFieldDecorator(
                                      `values[${sectionKey}].fields[${itemKey}].label`,
                                      {
                                        trigger: "onBlur",
                                        valuePropName: "defaultValue",
                                        rules: [
                                          {
                                            required: true,
                                            message: "Required",
                                          },
                                        ],
                                        initialValue: get(
                                          initialValues,
                                          `${sectionKey}.fields.${itemKey}.label`
                                        ),
                                      }
                                    )(<Input />)}
                                  </Form.Item>
                                </Col>
                                {![
                                  "InputSlider",
                                  "InputSignature",
                                  "InputUpload",
                                  "InputCheckboxGroup",
                                  "InputRadioGroup",
                                  "InputRadioBooleanGroup",
                                  "AgeFromField",
                                  "DateDeltaMinutesField",
                                  "HTMLBlock"
                                ].includes(
                                  getFieldValue(
                                    `values[${sectionKey}].fields[${itemKey}].type`
                                  )
                                ) && (
                                  <Col span={6}>
                                    <span>Placeholder:</span>
                                    <Form.Item>
                                      {getFieldDecorator(
                                        `values[${sectionKey}].fields[${itemKey}].placeholder`,
                                        {
                                          trigger: "onBlur",
                                          valuePropName: "defaultValue",
                                          initialValue: get(
                                            initialValues,
                                            `${sectionKey}.fields.${itemKey}.placeholder`
                                          ),
                                        }
                                      )(<Input />)}
                                    </Form.Item>
                                  </Col>
                                )}

                                {getFieldValue(
                                  `values[${sectionKey}].fields[${itemKey}].type`
                                ) === "AgeFromField" && (
                                  <React.Fragment>
                                  <Col span={10}>
                                    <span>Link to year input:</span>
                                    <Form.Item>
                                      {getFieldDecorator(
                                        `values[${sectionKey}].fields[${itemKey}].year_from`,
                                        {
                                          initialValue: get(
                                            initialValues,
                                            `${sectionKey}.fields.${itemKey}.year_from`
                                          ),
                                        }
                                      )(
                                        <Select style={{ width: "100%" }}>
                                          <Option
                                                value=""
                                                key=""
                                          >
                                            ------
                                          </Option>
                                          {map(
                                            this.getFields().filter(
                                              ({ fieldName, type }) =>
                                                fieldName !==
                                                  getFieldValue(
                                                    `values[${sectionKey}].fields[${itemKey}].fieldName`
                                                  ) &&
                                                [
                                                  "InputNumber",
                                                  "InputMonthPicker",
                                                ].includes(type)
                                            ),
                                            ({ fieldName }) => (
                                              <Option
                                                value={fieldName}
                                                key={fieldName}
                                              >
                                                {fieldName}
                                              </Option>
                                            )
                                          )}
                                        </Select>
                                      )}
                                    </Form.Item>
                                  </Col>
                                  <Col span={20}>
                                    <span>Age from date (field slug):</span>
                                    <p style={{color: "grey", fontSize: '10px'}}><i>The date starting from which the "age" value is calculated. Ex: age = to_date - from_date. Alternative to year input. Accepts a date or date_time field slug from this form.</i></p>
<Form.Item>
                                      {getFieldDecorator(
                                        `values[${sectionKey}].fields[${itemKey}].date_from_field`,
                                        {
                                          initialValue: get(
                                            initialValues,
                                            `${sectionKey}.fields.${itemKey}.date_from_field`
                                          ) || null,
                                        }
                                      )(
                                        <Select style={{ width: "100%" }}>
                                          <Option
                                                value={null}
                                                key={"-------"}
                                              >
                                                -------
                                              </Option>
                                          <Option
                                            value="randomization_date"
                                            key="randomization_date"
                                          >
                                            Randomization Date
                                          </Option>
                                          {map(
                                            this.getFields().filter(
                                              ({ type }) =>
                                                  (type === "InputDateTimepicker" || type === "InputDatepicker")
                                            ),
                                            ({ fieldName }) => (
                                              <Option
                                                value={fieldName}
                                                key={fieldName}
                                              >
                                                {fieldName}
                                              </Option>
                                            )
                                          )}
                                        </Select>
                                      )}
                                    </Form.Item>
                                  </Col>
                                  <Col span={20}>
                                    <span>Age up to date (field slug):</span>
                                    <p style={{color: "grey", fontSize: '10px'}}><i>The upper limit date to which the age will be calculated, defaults to now(). Accepts a date or date_time field slug from this form, or "randomization_date" in the randomization custom form. If this field is not set, the age field will recalculate when the form will be submitted next time.</i></p>
                                    <Form.Item>
                                      {getFieldDecorator(
                                        `values[${sectionKey}].fields[${itemKey}].date_to_field`,
                                        {
                                          initialValue: get(
                                            initialValues,
                                            `${sectionKey}.fields.${itemKey}.date_to_field`
                                          ),
                                        }
                                      )(
                                        <Select style={{ width: "100%" }}>
                                          <Option
                                                value={null}
                                                key={"-------"}
                                              >
                                                -------
                                              </Option>
                                          {map(
                                            this.getFields().filter(
                                              ({ type }) =>
                                                  (type === "InputDateTimepicker" || type === "InputDatepicker")
                                            ),
                                            ({ fieldName }) => (
                                              <Option
                                                value={fieldName}
                                                key={fieldName}
                                              >
                                                {fieldName}
                                              </Option>
                                            )
                                          )}
                                        </Select>
                                      )}
                                    </Form.Item>
                                  </Col>

                                  <Col span={6}>
                                    <span>Can be unlocked:</span>
                                    <p style={{color: "grey", fontSize: '10px'}}><i>By default this field is always read only. This option will add a button that will unlock this field and allow manual editing in the form.</i></p>

                                    <Form.Item>
                                      {getFieldDecorator(
                                        `values[${sectionKey}].fields[${itemKey}].can_be_unlocked`,
                                        {
                                          valuePropName: "checked",
                                          initialValue: get(
                                            initialValues,
                                            `${sectionKey}.fields.${itemKey}.can_be_unlocked`
                                          ),
                                        }
                                      )(<Checkbox />)}
                                    </Form.Item>
                                  </Col>
                                  </React.Fragment>
                                )}

                                {["InputSlider"].includes(
                                  getFieldValue(
                                    `values[${sectionKey}].fields[${itemKey}].type`
                                  )
                                ) && (
                                  <React.Fragment>
                                    <Col span={4}>
                                      <span>Min:</span>
                                      <Form.Item>
                                        {getFieldDecorator(
                                          `values[${sectionKey}].fields[${itemKey}].min`,
                                          {
                                            initialValue: get(
                                              this.props.initialValues,
                                              `${sectionKey}.fields.${itemKey}.min`
                                            ),
                                            rules: [
                                              {
                                                required: true,
                                                message: "Required",
                                              },
                                            ],
                                          }
                                        )(<Input />)}
                                      </Form.Item>
                                    </Col>

                                    <Col span={4}>
                                      <span>Max:</span>
                                      <Form.Item>
                                        {getFieldDecorator(
                                          `values[${sectionKey}].fields[${itemKey}].max`,
                                          {
                                            initialValue: get(
                                              this.props.initialValues,
                                              `${sectionKey}.fields.${itemKey}.max`
                                            ),
                                            rules: [
                                              {
                                                required: true,
                                                message: "Required",
                                              },
                                            ],
                                          }
                                        )(<Input />)}
                                      </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                      <span>Marks:</span>
                                      <Form.Item>
                                        {getFieldDecorator(
                                          `values[${sectionKey}].fields[${itemKey}].marks`,
                                          {
                                            initialValue: get(
                                              initialValues,
                                              `${sectionKey}.fields.${itemKey}.marks`
                                            ),
                                          }
                                        )(
                                          <Input.TextArea
                                            style={{ height: "100px" }}
                                            placeholder="0:0,&#10;100:100"
                                          />
                                        )}
                                      </Form.Item>
                                    </Col>
                                  </React.Fragment>
                                )}

                                {["InputSlider"].includes(
                                  getFieldValue(
                                    `values[${sectionKey}].fields[${itemKey}].type`
                                  )
                                ) && (
                                  <Col span={12}>
                                    <span>Is Slider vertical?</span>
                                    <Form.Item>
                                      {getFieldDecorator(
                                        `values[${sectionKey}].fields[${itemKey}].isSliderVertical`,
                                        {
                                          valuePropName: "checked",
                                          initialValue: get(
                                            initialValues,
                                            `${sectionKey}.fields.${itemKey}.isSliderVertical`
                                          ),
                                        }
                                      )(<Checkbox />)}
                                    </Form.Item>
                                  </Col>
                                )}
                              </Row>

                              {getFieldValue(
                                `values[${sectionKey}].fields[${itemKey}].type`
                              ) === "DateDeltaMinutesField" && (
                                <Row gutter={8}>
                                  <Col span={12}>
                                    <span>Date from:</span>
                                    <Form.Item>
                                      {getFieldDecorator(
                                        `values[${sectionKey}].fields[${itemKey}].date_from`,
                                        {
                                          initialValue: get(
                                            initialValues,
                                            `${sectionKey}.fields.${itemKey}.date_from`
                                          ),
                                        }
                                      )(
                                        <Select style={{ width: "100%" }}>
                                          {map(
                                            this.getFields().filter(
                                              ({ type }) =>
                                                type === "InputDateTimepicker"
                                            ),
                                            ({ fieldName }) => (
                                              <Option
                                                value={fieldName}
                                                key={fieldName}
                                              >
                                                {fieldName}
                                              </Option>
                                            )
                                          )}
                                        </Select>
                                      )}
                                    </Form.Item>
                                  </Col>
                                  <Col span={12}>
                                    <span>Date to:</span>
                                    <Form.Item>
                                      {getFieldDecorator(
                                        `values[${sectionKey}].fields[${itemKey}].date_to`,
                                        {
                                          initialValue: get(
                                            initialValues,
                                            `${sectionKey}.fields.${itemKey}.date_to`
                                          ),
                                        }
                                      )(
                                        <Select style={{ width: "100%" }}>
                                          {map(
                                            this.getFields().filter(
                                              ({ type }) =>
                                                type === "InputDateTimepicker"
                                            ),
                                            ({ fieldName }) => (
                                              <Option
                                                value={fieldName}
                                                key={fieldName}
                                              >
                                                {fieldName}
                                              </Option>
                                            )
                                          )}
                                          <Option
                                            value="randomization_time"
                                            key="randomization_time"
                                          >
                                            Now (Randomization time)
                                          </Option>
                                        </Select>
                                      )}
                                    </Form.Item>
                                  </Col>
                                </Row>
                              )}

                              {getFieldValue(
                                `values[${sectionKey}].fields[${itemKey}].type`
                              ) === "InputSelect" && (
                                <Row gutter={8}>
                                  <Col>
                                    <span>Select options:</span>
                                    <Form.Item>
                                      {getFieldDecorator(
                                        `values[${sectionKey}].fields[${itemKey}].options`,
                                        {
                                          initialValue: get(
                                            initialValues,
                                            `${sectionKey}.fields.${itemKey}.options`
                                          ),
                                          rules: [
                                            {
                                              required: true,
                                              message: "Required",
                                            },
                                          ],
                                        }
                                      )(
                                        <Input.TextArea
                                          placeholder="value:label,&#10;value:label"
                                          style={{ minHeight: "100px" }}
                                        />
                                      )}
                                    </Form.Item>
                                  </Col>
                                </Row>
                              )}

                              {[
                                "InputCheckboxGroup",
                                "InputRadioGroup",
                                "InputRadioBooleanGroup",
                              ].includes(
                                getFieldValue(
                                  `values[${sectionKey}].fields[${itemKey}].type`
                                )
                              ) && (
                                <Row gutter={8}>
                                  <Col>
                                    <span>Radio Group options:</span>
                                    <Form.Item>
                                      {getFieldDecorator(
                                        `values[${sectionKey}].fields[${itemKey}].options`,
                                        {
                                          initialValue: get(
                                            initialValues,
                                            `${sectionKey}.fields.${itemKey}.options`
                                          ),
                                          rules: [
                                            {
                                              required: true,
                                              message: "Required",
                                            },
                                          ],
                                        }
                                      )(
                                        <Input.TextArea
                                          placeholder="value:label,&#10;value:label"
                                          style={{ minHeight: "100px" }}
                                        />
                                      )}
                                    </Form.Item>
                                  </Col>
                                </Row>
                              )}
                            </React.Fragment>
                          )}

                        <div className={classes.conditions}>
                          <div className={classes.conditionsHeader}>
                            <Radio.Group size="small" value={conditionType}>
                              <Radio.Button
                                value="hardValidation"
                                onClick={() => {
                                  this.setState({
                                    conditionType: "hardValidation",
                                  });
                                }}
                              >
                                Hard Validation
                                {conditionHardValidationGroupKeys[itemKey] &&
                                  conditionHardValidationGroupKeys[itemKey]
                                    .length > 0 && (
                                    <Badge
                                      count={
                                        conditionHardValidationGroupKeys[
                                          itemKey
                                        ].length
                                      }
                                      style={{
                                        margin: "-1px 0 0 5px",
                                        backgroundColor: "var(--primary-color)",
                                      }}
                                    />
                                  )}
                              </Radio.Button>
                              <Radio.Button
                                value="softValidation"
                                onClick={() => {
                                  this.setState({
                                    conditionType: "softValidation",
                                  });
                                }}
                              >
                                Soft Validation
                                {conditionSoftValidationGroupKeys[itemKey] &&
                                  conditionSoftValidationGroupKeys[itemKey]
                                    .length > 0 && (
                                    <Badge
                                      count={
                                        conditionSoftValidationGroupKeys[
                                          itemKey
                                        ].length
                                      }
                                      style={{
                                        margin: "-1px 0 0 5px",
                                        backgroundColor: "var(--primary-color)",
                                      }}
                                    />
                                  )}
                              </Radio.Button>
                              <Radio.Button
                                value="conditions"
                                onClick={() => {
                                  this.setState({
                                    conditionType: "conditions",
                                  });
                                }}
                              >
                                Conditions
                                {conditionGroupKeys[itemKey] &&
                                  conditionGroupKeys[itemKey].length > 0 && (
                                    <Badge
                                      count={conditionGroupKeys[itemKey].length}
                                      style={{
                                        margin: "-1px 0 0 5px",
                                        backgroundColor: "var(--primary-color)",
                                      }}
                                    />
                                  )}
                              </Radio.Button>
                              <Radio.Button
                                onClick={() => {
                                  this.setState({
                                    conditionType: "conditionsRequired",
                                  });
                                }}
                                value="conditionsRequired"
                              >
                                Conditions for required
                                {conditionRequiredGroupKeys[itemKey] &&
                                  conditionRequiredGroupKeys[itemKey].length >
                                    0 && (
                                    <Badge
                                      count={
                                        conditionRequiredGroupKeys[itemKey]
                                          .length
                                      }
                                      style={{
                                        margin: "-1px 0 0 5px",
                                        backgroundColor: "var(--primary-color)",
                                      }}
                                    />
                                  )}
                              </Radio.Button>
                            </Radio.Group>
                          </div>

                          <div
                            style={{
                              display:
                                conditionType === "conditions"
                                  ? "block"
                                  : "none",
                            }}
                          >
                            {this.conditionBlock({
                              conditionKeys,
                              conditionGroupKeys,
                              conditionGroupKeysName: "conditionGroupKeys",
                              initialValues,
                              sectionKey,
                              itemKey,
                              fieldNames,
                              getFieldValue,
                              getFieldDecorator,
                              onDeleteCondition: this.onDeleteCondition,
                              conditionName: "conditions",
                              conditionKeysName: "conditionKeys",
                            })}
                          </div>

                          <div
                            style={{
                              display:
                                conditionType === "hardValidation"
                                  ? "block"
                                  : "none",
                            }}
                          >
                            {this.conditionBlock({
                              conditionType,
                              conditionKeys: conditionHardValidationKeys,
                              conditionGroupKeys: conditionHardValidationGroupKeys,
                              conditionGroupKeysName:
                                "conditionHardValidationGroupKeys",
                              initialValues,
                              sectionKey,
                              itemKey,
                              fieldNames,
                              getFieldValue,
                              getFieldDecorator,
                              onDeleteCondition: this.onDeleteCondition,
                              conditionName: "hardValidation",
                              conditionKeysName: "conditionHardValidationKeys",
                            })}
                          </div>

                          <div
                            style={{
                              display:
                                conditionType === "softValidation"
                                  ? "block"
                                  : "none",
                            }}
                          >
                            {this.conditionBlock({
                              conditionType,
                              conditionKeys: conditionSoftValidationKeys,
                              conditionGroupKeys: conditionSoftValidationGroupKeys,
                              conditionGroupKeysName:
                                "conditionSoftValidationGroupKeys",
                              initialValues,
                              sectionKey,
                              itemKey,
                              fieldNames,
                              getFieldValue,
                              getFieldDecorator,
                              onDeleteCondition: this.onDeleteCondition,
                              conditionName: "softValidation",
                              conditionKeysName: "conditionSoftValidationKeys",
                            })}
                          </div>

                          <div
                            style={{
                              display:
                                conditionType === "conditionsRequired"
                                  ? "block"
                                  : "none",
                            }}
                          >
                            {this.conditionBlock({
                              conditionKeys: conditionRequiredKeys,
                              conditionGroupKeys: conditionRequiredGroupKeys,
                              conditionGroupKeysName:
                                "conditionRequiredGroupKeys",
                              initialValues,
                              sectionKey,
                              itemKey,
                              fieldNames,
                              getFieldValue,
                              getFieldDecorator,
                              onDeleteCondition: this.onDeleteCondition,
                              conditionName: "conditionsRequired",
                              conditionKeysName: "conditionRequiredKeys",
                            })}
                          </div>
                        </div>

                        <p>
                          <Button
                            size="small"
                            type="dashed"
                            style={{ marginTop: "0" }}
                            onClick={() => {
                              this.setEdit(null);
                            }}
                          >
                            Done
                          </Button>
                        </p>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
    );
  }
}

export default Form.create({ name: "FormBuilderCustom" })(
  withNamespaces()(FormBuilderCustom)
);



// WEBPACK FOOTER //
// ./src/containers/FormBuilder/FormBuilderCustom.js